import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import i18next from "i18next";
import SubScheduleVacationList from "./SubScheduleVacationList";
import DelegateScheduleVacation from "./DelegateScheduleVacation";
import MnComboStandalone from "@mnjsplatform/components/lib/common/Dropdown/MnComboStandalone";

class SubScheduleVacation extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            currentYear: null, methodInfo: null
        };
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.SchedHolidayYear_SelectOnePO.reset());
            await this.props.dispatch(this.props.SchedHolidayYear_SelectOnePO.initialize());
            await this.changeYear(0);
        } catch (e) {
            console.error(e);
        }
    }

    refresh = async () => {
        let key = {"NumYear": this.state.currentYear};
        await this.props.dispatch(this.props.ShedHolidayDetail_GetViewDetail.execute(key));
        const methodInfo = this.props.ShedHolidayDetail_GetViewDetail.getRow(0);
        this.setState({methodInfo: methodInfo});
    }

    changeYear = async (selectedIndex) => {
        if (selectedIndex < 0) return;
        const row = this.props.SchedHolidayYear_SelectOnePO.getRow(selectedIndex);
        this.setState({currentYear: row.NumYear}, this.refresh);
    }

    render() {
        if (!this.state.methodInfo) return null;
        return (<>
{/*
                <PlaceholderWrapper placeholderId="10"
                                    showSplitterLine={false}
                                    collapsed={false}
                                    title={<><i className='fa fa-info'/>
                                        <a target="_blank" rel="noopener noreferrer"
                                           href='https://carlsberggroup.sharepoint.com/russia/departments/hr/Pages/Service/vacation_schedule3.aspx'>&nbsp;
                                            {i18next.t("Внесение данных и согласование отпусков подчиненных в КР (sharepoint.com)")}
                                        </a></>}
                                    canCollapse={false}>
                </PlaceholderWrapper>
*/}

                <PlaceholderWrapper placeholderId="SubScheduleVacation_20" title={i18next.t("Sub_Vacation_Schedule_List")}
                                    showSplitterLine={false}
                                    canCollapse={false}>
                    <div className="d-inline-flex p-2">{i18next.t("VacationsFor")}&nbsp;
                        <MnComboStandalone
                            ownItem={this.props.SchedHolidayYear_SelectOnePO}
                            style={{cursor: 'pointer'}}
                            valueFieldName="NumYear"
                            withSearch={false} onSelected={this.changeYear}/>
                    </div>
                </PlaceholderWrapper>
                <DelegateScheduleVacation currentYear={this.state.currentYear}/>
                <PlaceholderWrapper placeholderId="SubScheduleVacation_30"
                                    title={i18next.t("VacationSchedule", {year: this.state.currentYear})}
                                    staticTitle={i18next.t("VacationSchedule")}
                                    showSplitterLine={false}>
                    <SubScheduleVacationList currentYear={this.state.currentYear}
                                             methodInfo={this.state.methodInfo}
                                             readOnly={this.state.methodInfo && this.state.methodInfo.IsReadOnly === 1}/>
                </PlaceholderWrapper>
            </>);
    }
}

SubScheduleVacation.propTypes = {
    dispatch: PropTypes.func.isRequired,
    SchedHolidayYear_SelectOnePO: PropTypes.object,
    ShedHolidayDetail_GetViewDetail: PropTypes.object
};

SubScheduleVacation.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        SchedHolidayYear_SelectOnePO: state.vacationState.SchedHolidayYear_SelectOnePO,
        ShedHolidayDetail_GetViewDetail: state.vacationState.ShedHolidayDetail_GetViewDetail
    }
}

export default connect(mapStateToProps)(SubScheduleVacation);